// extracted by mini-css-extract-plugin
export default {"filterWrapper":"ProductionBase_filterWrapper__5OTWQ","spaceStyle":"ProductionBase_spaceStyle__5N0AU"};